import { useEffect, useState } from 'react';

/**
 * visualViewport 기반 바텀시트 키보드 대응 훅.
 * 소프트 키보드가 올라올 때 시트가 키보드 위에 위치하도록 bottom/maxHeight를 계산합니다.
 *
 * @param isOpen 시트가 열려있는지 여부
 * @returns 시트 div에 적용할 style 객체
 */
export function useBottomSheetKeyboard(isOpen: boolean): { bottom?: number | string; maxHeight?: number | string } {
  const [sheetStyle, setSheetStyle] = useState<{ bottom?: number | string; maxHeight?: number | string }>({});

  useEffect(() => {
    if (!isOpen) {
      setSheetStyle({});
      return;
    }
    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      const keyboardHeight = window.innerHeight - (vv.offsetTop + vv.height);
      if (keyboardHeight > 50) {
        setSheetStyle({
          bottom: keyboardHeight,
          maxHeight: vv.height * 0.95,
        });
      } else {
        setSheetStyle({
          bottom: 0,
          maxHeight: '70vh',
        });
      }
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, [isOpen]);

  return sheetStyle;
}
